// 課金-ADD-START
import React from "react";
import i18n from "i18next";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { api } from "@/utils/api";
import { isPOC } from "@/utils";
import { updateAgreementStatusInfo as updateAgreementStatusInfoDispatch } from "@/models/user";
import ConfirmHeader from "@/react-components/Confirm/Header";
import ConfirmBody from "@/react-components/Confirm/Body";

class ConfirmPaymentAgreementSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = { data: null };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    api.agreement
      .getLoginPaymentProtocal()
      .then((response) => {
        this.setState({
          data: response,
        });
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  next = () => {
    const { updateAgreementStatusInfo, authentication } = this.props;
    const { data } = this.state;
    if (isPOC()) {
      updateAgreementStatusInfo({
        agreementStatusInfo: {
          termsAgreementInfo: {
            termsOfServiceVer: "1.0",
            privacyPolicyVer: "",
            contactFeatureVer: "",
            bmSupportPlanTermsOfServiceVer: "1.0",
          },
        },
      });
    } else {
      api.agreement
        .updateLoginPaymentProtocal({
          userid: authentication?.accountId,
          version: data?.version,
        })
        .then(() => {
          api.user.getAgreementStatus().then((response1) => {
            updateAgreementStatusInfo({ agreementStatusInfo: response1 });
          });
        })
        .catch((error) => {
          console.error("error: " + error.message);
        });
    }
  };

  render() {
    const { data } = this.state;
    return (
      <div className="confirm-payment-agreement-container">
        <ConfirmHeader stepIndex={1} />
        {data ? (
          <ConfirmBody
            className="confirm-payment-agreement-container-body"
            title={i18n.t("TCCs0032_confirm_payment_agreement_content_title")}
            content={data.contentText}
            checkboxText={i18n.t(
              "TCCs0032_confirm_payment_agreement_checkbox_title"
            )}
            onClick={this.next}
            downloadUrl={i18n.t(
              "payment_agreement_applicable_version_download_url"
            )}
          />
        ) : null}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    state: state?.user?.authState,
    authentication: state?.user?.authentication,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateAgreementStatusInfo: (action) =>
      dispatch(updateAgreementStatusInfoDispatch(action)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(ConfirmPaymentAgreementSection));

// 課金-ADD-END
